import type { StoreSettings } from "../lib/api";

type HeaderProps = {
  store: StoreSettings;
};

export function Header({ store }: HeaderProps) {
  return (
    <header className="profile-header">
      <img className="profile-avatar" src={store.avatarUrl ?? "/icons/icon.svg"} alt="" />
      <div className="profile-copy">
        <div className="profile-title-row">
          <h1>{store.name}</h1>
        </div>
        <p>{store.description}</p>
      </div>
    </header>
  );
}
